import { CrmContactViewModel } from 'sdk'
import { BaseApi } from 'sdk/api-services/base.api'
import { apiUrls } from 'sdk/api-urls'

const baseApi = new BaseApi()
export class CrmCompanyLinkedContactsApi {
  public getCompanyLinkedContacts(companyId: string) {
    return baseApi.GET_Request<CrmContactViewModel[]>(
      apiUrls.crm.companyLinkedContacts.getCompanyLinkedContacts(companyId)
    )
  }
  public getCompanyUnlinkedContact(companyId: string) {
    return baseApi.GET_Request<CrmContactViewModel[]>(
      apiUrls.crm.companyLinkedContacts.getCompanyUnLinkedContacts(companyId)
    )
  }
}
